import { format, formatDate, isValid } from "date-fns";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

export const numberFormatter = new Intl.NumberFormat("cs-CZ");

export const floorFormatter = (
	from: number | null | undefined,
	to: number | null | undefined,
	emptyVal = "",
) => {
	if (!from && !to) return emptyVal;
	if (!from) return `${to}`;
	if (!to) return `${from}`;

	return `${from} - ${to}`;
};

export const unitFormatter = (
	val: number | null | undefined,
	unit = "m²",
	emptyVal = "",
) => {
	return val ? `${val.toLocaleString("cs-CZ")} ${unit}` : emptyVal;
};

export const moneyFormatter = (
	val: string | number | null | undefined,
	currencySign: string,
	emptyVal = "",
	decimals?: number,
) => {
	if (val === null || val === undefined || val === "") return emptyVal;

	const numVal = Number(val);
	if (Number.isNaN(numVal)) return emptyVal;

	const formattedVal =
		decimals !== undefined ? numVal.toFixed(decimals) : numVal.toString();

	return `${Number(formattedVal).toLocaleString("cs-CZ")}\u00A0${currencySign}`;
};

export const dateFormatter = (
	val: Date | string | null | undefined,
	emptyVal = "",
	format: string = DateFormat.Display,
) => (val ? formatDate(val, format) : emptyVal);

export const roundNumber = (val: number, decimalPlaces = 2): number =>
	Number(val.toFixed(decimalPlaces));

export const capitalizeFirstLetter = (str: string | null | undefined) => {
	if (!str) return "";

	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const nameFormatter = (
	fullName: string,
	bornDate?: string | null,
	identificationNumber?: string | null,
): string => {
	let output = fullName;

	const parsedDate = bornDate ? new Date(bornDate) : null;
	const bornDateValid = parsedDate && isValid(parsedDate);

	if (bornDateValid) {
		output += ` (${format(parsedDate, DateFormat.DisplayShort)})`;
	} else if (identificationNumber) {
		output += ` (${identificationNumber})`;
	}

	return output;
};
